module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-anon-wrapper"
  }, [_c('div', {
    staticClass: "devNote"
  }, [_vm._v("v_3.4.2")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69703de0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AnonUserPage.vue
// module id = 785
// module chunks = 2